import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import AnalyticsService from 'cio/services/analytics';
import ExperimentalFeaturesController from './controller';
import Transition from '@ember/routing/-private/transition';
import { redirectIfNoJourneysAccess } from 'cio/utils/route-access';

export default class ExperimentalFeaturesRoute extends Route {
  @service features!: FeaturesService;
  @service analytics!: AnalyticsService;

  setupController(controller: ExperimentalFeaturesController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);

    this.analytics.track('experimental_features', 'viewed');
  }

  crumb() {
    return {
      name: 'Experimental Features',
      path: this.routeName,
      helpQuery: 'experimental features',
    };
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    return redirectIfNoJourneysAccess(this, transition, 'experimentalFeatures');
  }
}
